import React, { Component } from 'react';
import './scss/custom.scss';
import ReactLoading from 'react-loading';
import pdfIcon from './image/PDF.ico';


const TextCenter = { textAlign: "center" };
const Width10per = { width: "5%" }
const loadingGif = {
    position: "absolute",
    top: "50%",
    left: "45%"
};
const thHeader = {
    textAlign: "center",
    border: "none"
}

export class DocumentStore extends Component {
    static displayName = DocumentStore.name;
    constructor(props) {
        super(props);
        this.state = { docs: [], loading: true, updatedOn: '' };
        this.loadData();
    }

    loadData = () => {
        fetch('api/SubmissionStatus/GetDocuments')
            .then(response => response.json())
            .then(data => {
                this.setState({ docs: data, loading: false, updatedOn: '' });
            });
    }

    downloadFile = (e, filePath, fileName) => {
        e.preventDefault();
        fetch('api/SubmissionStatus/Download?documentType=application/pdf&documentPath=' + filePath)
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const file = filePath.split('.');
                const extenstion = file[file.length - 1];
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName + '.' + extenstion);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            });
    }

    getDateTime = (lastUpdatedTime) => {
        var updatedDate = new Date(lastUpdatedTime);
        var options = {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric',
            hour12: false
        };
        return (new Intl.DateTimeFormat('en-GB', options).format(updatedDate).replace(',', ''));
    }

    getDocuments = (docs) => {
        const documents = docs.map((doc) => {
            return (<tr>
                <td className="tdFont" style={Width10per}><img src={pdfIcon} width="27" height="25" className="img-responsive" /></td>
                <td className="tdFont" align="center"> {doc.document_Name} </td>
                <td className="tdFont" align="center"> {this.getDateTime(doc.last_Updated)} </td>
                <td className="tdFont" align="center"> <a href='#' onClick={(e) => this.downloadFile(e, doc.document_Path, doc.document_Name)}>Download</a></td>
            </tr >);
        });
        return documents;
    }

    renderDocumentTable = (documents) => {

        return (
            <div>
                <div className="btnrr"><span className="timeText">{this.state.updatedOn}</span></div>
                <div className="headerAlign">{this.props.displayName}</div>
                <br /><br /><br />
                <table className="table submissionStatus">
                    <thead>
                        <tr>
                            <th style={thHeader} className="tdFont" style={Width10per}>
                                &nbsp;
                            </th>
                            <th style={thHeader} className="tdFont">
                                Description
                            </th>
                            <th style={thHeader} className="tdFont">
                                Last Updated
                                </th>
                            <th style={thHeader} className="tdFont">
                                Action
                                    </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getDocuments(documents)}
                    </tbody>
                </table>

            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <div><ReactLoading type={"spokes"} color={"#000"} height={'7%'} width={'7%'} style={loadingGif} /></div>
            : this.renderDocumentTable(this.state.docs);

        return (<div>
            {contents}
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/DocumentStore.js